import { render, staticRenderFns } from "./SocialPostsNew.vue?vue&type=template&id=44baf5e0&"
import script from "./SocialPostsNew.vue?vue&type=script&lang=js&"
export * from "./SocialPostsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports